<div *ngIf="showRequest" class="">
  <h2 class="sectionTitle">{{'ADMIN_USER.E_TENDER_FORM.TENDER_CREATION' | translate }}</h2>
  <form [formGroup]="createTenderForm">
    <fieldset [disabled]="formMode == 2" #createTender>
      <div class="form-container">
        <h4 class="section-title">{{'ADMIN_USER.E_TENDER_FORM.BASIC_INFO' | translate }}</h4>
        <!--language-->
        <div class="form-group">
          <label for="languageId">{{'ADMIN_USER.E_TENDER_FORM.LANGUAGE' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <select id="Language" name="Language" class="form-control" formControlName="Language"
            (change)="languageChanged($event)">
            <ng-container *ngFor="let language of languages">
              <option *ngIf="displayedLang=='NameEN'" [value]="language.Id">
                {{language.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="language.Id">
                {{language.NameAR}}
              </option>
            </ng-container>
          </select>
          <div *ngIf="submitted && Validate.Language?.errors" class="red">
            <div *ngIf="Validate.Language?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
          </div>
        </div>
        <!--Tender Type-->
        <div class="form-group">
          <label for="TenderTypeId">{{'ADMIN_USER.E_TENDER_FORM.TENDER_TYPE' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <select id="TenderTypeId" name="TenderTypeId" class="form-control" formControlName="TenderTypeId"
            (change)="tenderTypeChanged($event)">
            <ng-container *ngFor="let tenderType of TenderTypes">
              <option *ngIf="displayedLang=='NameEN'" [value]="tenderType.Id">
                {{tenderType.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="tenderType.Id">
                {{tenderType.NameAR}}
              </option>
            </ng-container>
          </select>
          <div
            *ngIf="(submitted && Validate.TenderTypeId?.errors)||(submitted && createTenderForm.controls['TenderTypeId']?.value == 0)"
            class="red">
            <div *ngIf="Validate.TenderTypeId?.errors?.required||createTenderForm.controls['TenderTypeId']?.value == 0">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
          </div>
        </div>
        <!--TitleAr -->
        <div class="form-group"
          *ngIf="createTenderForm.controls['Language']?.value == 1 || createTenderForm.controls['Language']?.value == 3">
          <label for="TitleAR">{{ 'ADMIN_USER.E_TENDER_FORM.TITLE_AR' | translate }}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <textarea type="text" id="TitleAR" name="TitleAR" class="form-control" formControlName="TitleAR"></textarea>
          <div *ngIf="submitted && Validate.TitleAR?.errors" class="red ">
            <div *ngIf="Validate.TitleAR?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.TitleAR?.errors?.pattern">
              {{'ADMIN_USER.SHARED.PATTERN' | translate}}
            </div>
          </div>

        </div>
        <!--TitleEn -->
        <div class="form-group"
          *ngIf="createTenderForm.controls['Language']?.value == 2 || createTenderForm.controls['Language']?.value == 3">
          <label for="TitleEN">{{ 'ADMIN_USER.E_TENDER_FORM.TITLE_EN' | translate }}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <textarea type="text" id="TitleEN" name="TitleEN" class="form-control" formControlName="TitleEN"></textarea>
          <div *ngIf="submitted && Validate.TitleEN?.errors" class="red ">
            <div *ngIf="Validate.TitleEN?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.TitleEN?.errors?.pattern">
              {{'ADMIN_USER.SHARED.PATTERN' | translate}}
            </div>
          </div>

        </div>
        <!-- ARمكان الجلسة-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['Language']?.value == 1 || createTenderForm.controls['Language']?.value == 3">
          <label for="SessionPlaceAR">{{ 'ADMIN_USER.E_TENDER_FORM.SESSION_PLACE_AR' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <input type="text" formControlName="SessionPlaceAR" name="SessionPlaceAR" id="SessionPlaceAR"
            class="form-control" />
          <div *ngIf="submitted && Validate.SessionPlaceAR?.errors" class="red ">
            <div *ngIf="Validate.SessionPlaceAR?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.SessionPlaceAR?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
            <div *ngIf="Validate.SessionPlaceAR?.errors?.pattern">
              {{'ADMIN_USER.SHARED.PATTERN' | translate}}
            </div>
          </div>
        </div>
        <!-- ENمكان الجلسة-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['Language']?.value == 2 || createTenderForm.controls['Language']?.value == 3">
          <label for="SessionPlaceEN">{{ 'ADMIN_USER.E_TENDER_FORM.SESSION_PLACE_EN' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <input type="text" formControlName="SessionPlaceEN" name="SessionPlaceEN" id="SessionPlaceEN"
            class="form-control" />
          <div *ngIf="submitted && Validate.SessionPlaceEN?.errors" class="red ">
            <div *ngIf="Validate.SessionPlaceEN?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.SessionPlaceEN?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
            <div *ngIf="Validate.SessionPlaceEN?.errors?.pattern">
              {{'ADMIN_USER.SHARED.PATTERN' | translate}}
            </div>
          </div>
        </div>
        <!--*المجالات المطلوبة-->
        <div class="form-group">
          <label for="msCategory">{{ 'ADMIN_USER.E_TENDER_FORM.ETENDERS_CATEGORIES' | translate }}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <ng-multiselect-dropdown id="msCategory" [formControl]="Validate['ETendersCategories']"
            placeholder="{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}" 
            [settings]="dropdownSettings" [data]="categoriesList" [disabled]="formMode == 2"
            (onDropDownClose)="CategoriesChanged()" [disabled]="formMode == 2">
          </ng-multiselect-dropdown>
          <div *ngIf="submitted && Validate.ETendersCategories?.errors" class="red">
            <div *ngIf="Validate.ETendersCategories?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
          </div>
        </div>
        <!--*Publishing date and time-->
        <div class="form-group">
          <label for="PD">{{ 'ADMIN_USER.E_TENDER_FORM.PUBLISH_DATE' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <div class="split-form-group ">
            <input class="form-control" (keydown.Tab)="$event.preventDefault()" [minDate]="getMinPublishDate"
              #datepickerYMD="bsDatepicker" bsDatepicker formControlName="PD"
              [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
              [ngClass]="{ 'is-invalid': submitted ||(Validate.PD?.dirty  && Validate.PD?.errors) }">
            <timepicker id="PDTime" [hourStep]="1" [minuteStep]="1" [formControl]="createTenderForm.controls['PDTime']"
              [disabled]="formMode == 2">
            </timepicker>
          </div>
          <div *ngIf="submitted && (Validate.PDTime?.errors || Validate.PD?.errors)" class="red ">
            {{'ADMIN_USER.SHARED.REQUIRED' | translate}}
          </div>
        </div>

      </div>
      <div class="form-container"
        *ngIf="createTenderForm.controls['TenderTypeId']?.value ==  ETenderTypes.PublicBidding">
        <!--Day & Date  Day & Dateاليوم والتاريخ-->
        <div class="form-group">
          <label>{{ 'ADMIN_USER.E_TENDER_FORM.DATE' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <input class="form-control" (keydown.Tab)="$event.preventDefault()" #datepickerYMD="bsDatepicker" bsDatepicker
            formControlName="Date" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }" [minDate]="getMinTenderDate"
            [ngClass]="{ 'is-invalid': submitted ||Validate.Date?.errors }" [minDate]='today'>
          <div *ngIf="submitted ||(Validate.Date?.dirty && Validate.Date?.errors)" class="red ">
            <div *ngIf="Validate.Date?.errors?.required">
              {{'ADMIN_USER.SHARED.REQUIRED' | translate}}
            </div>
            <div *ngIf="Validate.Date?.errors?.inValidDateError">
              {{'ADMIN_USER.SHARED.DATE_ERROR' | translate}}
            </div>
          </div>
        </div>
        <!--Time-->
        <div class="form-group">
          <label for="Time">{{ 'ADMIN_USER.E_TENDER_FORM.TIME' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <div class="split-form-group ">
            <timepicker id="Time" formControlName="Time" [hourStep]="1" [minuteStep]="1" [disabled]="formMode == 2">
            </timepicker>
          </div>
          <div *ngIf="submitted  && Validate.Time?.errors" class="red ">
            <div *ngIf="Validate.Time?.errors?.required">{{'ADMIN_USER.SHARED.REQUIRED' | translate}}</div>
          </div>
        </div>
        <!--*سعر كراسة الشروط-->
        <div class="form-group">
          <label for="BookletPrice">{{ 'ADMIN_USER.E_TENDER_FORM.BOOKLET_PRICE' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <div class="input-group">
            <input type="number" formControlName="BookletPrice" name="BookletPrice" id="BookletPrice"
              class="form-control" min="0" onkeypress="return event.charCode >= 48" />
            <span class="input-group-addon">{{ 'ADMIN_USER.E_TENDER_FORM.EGYPTIAN_POUND' | translate}}</span>
          </div>
          <div *ngIf="submitted && Validate.BookletPrice?.errors" class="red ">
            <div *ngIf="Validate.BookletPrice?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.BookletPrice?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
          </div>
        </div>
        <!--التأمين-->
        <div class="form-group">
          <label for="InsuranceValue">{{ 'ADMIN_USER.E_TENDER_FORM.INSURANCE_VALUE' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <div class="input-group">
            <input type="number" formControlName="InsuranceValue" name="InsuranceValue" id="InsuranceValue"
              class="form-control" min="0" onkeypress="return event.charCode >= 48" />
            <span class="input-group-addon">{{ 'ADMIN_USER.E_TENDER_FORM.EGYPTIAN_POUND' | translate}}</span>
          </div>
          <div *ngIf="submitted && Validate.InsuranceValue?.errors" class="red ">
            <div *ngIf="Validate.InsuranceValue?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.InsuranceValue?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
          </div>
        </div>
        <!--General TermsARشروط عامة-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['Language']?.value == 1 || createTenderForm.controls['Language']?.value == 3">
          <label for="GeneralTermsAR">{{ 'ADMIN_USER.E_TENDER_FORM.GENERAL_TERMS_AR' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <textarea formControlName="GeneralTermsAR" name="GeneralTermsAR" class="form-control"></textarea>
          <div *ngIf="submitted && Validate.GeneralTermsAR?.errors" class="red ">
            <div *ngIf="Validate.GeneralTermsAR?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.GeneralTermsAR?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
            <div *ngIf="Validate.GeneralTermsAR?.errors?.pattern">
              {{'ADMIN_USER.SHARED.PATTERN' | translate}}
            </div>
          </div>
        </div>
        <!--General TermsEN شروط عامة-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['Language']?.value == 2 || createTenderForm.controls['Language']?.value == 3">
          <label for="GeneralTermsEN">{{ 'ADMIN_USER.E_TENDER_FORM.GENERAL_TERMS_EN' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <textarea formControlName="GeneralTermsEN" name="GeneralTermsEN" class="form-control"></textarea>
          <div *ngIf="submitted && Validate.GeneralTermsEN?.errors" class="red ">
            <div *ngIf="Validate.GeneralTermsEN?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.GeneralTermsEN?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
            <div *ngIf="Validate.GeneralTermsEN?.errors?.pattern">
              {{'ADMIN_USER.SHARED.PATTERN' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="form-container"
        *ngIf="createTenderForm.controls['TenderTypeId']?.value != null && createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.PublicBidding">
        <!--Tender Number-->
        <div class="form-group" *ngIf="createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.Quotations">
          <label for="TenderNumber"
            *ngIf="createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.Practice">{{ 'ADMIN_USER.E_TENDER_FORM.TENDER_NUMBER' | translate }}</label>
          <label for="TenderNumber"
            *ngIf="createTenderForm.controls['TenderTypeId']?.value == ETenderTypes.Practice">{{ 'ADMIN_USER.E_TENDER_FORM.PRACTICE_NUMBER' | translate }}</label>
          <span class="red"
            *ngIf="formMode != 2 && createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.Practice"> *</span>
          <input type="text" id="TenderNumber" name="TenderNumber" class="form-control"
            formControlName="TenderNumber" />
          <div *ngIf="submitted && Validate.TenderNumber?.errors" class="red ">
            <div *ngIf="Validate.TenderNumber?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.TenderNumber?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
            <div *ngIf="Validate.TenderNumber?.errors?.pattern">
              {{'ADMIN_USER.SHARED.PATTERN' | translate}}
            </div>
          </div>
        </div>
        <!--File number-->
        <div class="form-group">
          <label for="FileNumber">{{ 'ADMIN_USER.E_TENDER_FORM.FILE_NUMBER' | translate }}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <input type="text" id="FileNumber" name="FileNumber" class="form-control" formControlName="FileNumber" />
          <div *ngIf="submitted && Validate.FileNumber?.errors" class="red ">
            <div *ngIf="Validate.FileNumber?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.FileNumber?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
            <div *ngIf="Validate.FileNumber?.errors?.pattern">
              {{'ADMIN_USER.SHARED.PATTERN' | translate}}
            </div>
          </div>
        </div>
        <!--Financial year-->
        <div class="form-group">
          <label>{{ 'ADMIN_USER.E_TENDER_FORM.FINANCIAL_YEAR' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="FinancialYear"
            [minDate]="getMinFinancialYear"
            [bsConfig]="{ dateInputFormat: 'YYYY' , minMode: 'year', datepickerMode: 'year' }"
            [ngClass]="{ 'is-invalid': submitted ||Validate.FinancialYear?.errors }">
          <div *ngIf="submitted ||(Validate.FinancialYear.dirty && Validate.FinancialYear?.errors)" class="red ">
            <div *ngIf="Validate.FinancialYear?.required">
              {{'ADMIN_USER.SHARED.REQUIRED' | translate}}
            </div>
            <div *ngIf="Validate.FinancialYear?.errors?.inValidDateError">
              {{'ADMIN_USER.SHARED.DATE_ERROR' | translate}}
            </div>
          </div>
        </div>
        <!--التأمين الإبتدائي-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.Quotations && createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.Practice">
          <label
            for="PrimaryInsuranceValue">{{ 'ADMIN_USER.E_TENDER_FORM.PRIMARY_INSURANCE_VALUE' | translate }}</label>
          <input type="text" id="PrimaryInsuranceValue" name="PrimaryInsuranceValue" class="form-control"
            formControlName="PrimaryInsuranceValue" />
          <div *ngIf="submitted && Validate.PrimaryInsuranceValue?.errors" class="red ">
            <div *ngIf="Validate.PrimaryInsuranceValue?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.PrimaryInsuranceValue?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
          </div>
        </div>
        <!--*نوع المناقصة-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.Quotations && createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.Practice">
          <label for="TenderMethodId">{{'ADMIN_USER.E_TENDER_FORM.TENDER_METHOD' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <select id="TenderMethodId" name="TenderMethodId" class="form-control" formControlName="TenderMethodId">
            <ng-container *ngFor="let tenderMethod of TenderMethods">
              <option *ngIf="displayedLang=='NameEN'" [value]="tenderMethod.Id">
                {{tenderMethod.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="tenderMethod.Id">
                {{tenderMethod.NameAR}}
              </option>
            </ng-container>
          </select>
          <div *ngIf="submitted && Validate.TenderMethodId?.errors" class="red">
            <div *ngIf="Validate.TenderMethodId?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
          </div>
        </div>
        <!--?*تقديم عرض لعقد الصيانة-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.Quotations && createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.Practice">
          <label
            for="HaveMaintenanceContract">{{'ADMIN_USER.E_TENDER_FORM.HAVE_MAINTENANCE_CONTRACT' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <select id="HaveMaintenanceContract" name="HaveMaintenanceContract" class="form-control"
            formControlName="HaveMaintenanceContract">
            <ng-container *ngFor="let bool of booleans">
              <option *ngIf="displayedLang=='NameEN'" [value]="bool.Id">
                {{bool.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="bool.Id">
                {{bool.NameAR}}
              </option>
            </ng-container>
          </select>
          <div *ngIf="submitted && Validate.HaveMaintenanceContract?.errors" class="red">
            <div *ngIf="Validate.HaveMaintenanceContract?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
          </div>
        </div>
        <!--قيمة عقد الصيانة-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['HaveMaintenanceContract']?.value =='true' || createTenderForm.controls['HaveMaintenanceContract']?.value ==true">
          <label
            for="MaintenanceContractValue">{{ 'ADMIN_USER.E_TENDER_FORM.MAINTENANCE_CONTRACT_VALUE' | translate }}</label>
          <input type="text" id="MaintenanceContractValue" name="MaintenanceContractValue" class="form-control"
            formControlName="MaintenanceContractValue" />
          <div *ngIf="submitted && Validate.MaintenanceContractValue?.errors" class="red ">
            <div *ngIf="Validate.MaintenanceContractValue?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.MaintenanceContractValue?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
          </div>
        </div>
        <!--*تقبل التجزئة-->
        <div class="form-group">
          <label for="AcceptRetail">{{'ADMIN_USER.E_TENDER_FORM.ACCEPT_RETAIL' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <select id="AcceptRetail" name="AcceptRetail" class="form-control" formControlName="AcceptRetail">
            <ng-container *ngFor="let bool of booleans">
              <option *ngIf="displayedLang=='NameEN'" [value]="bool.Id">
                {{bool.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="bool.Id">
                {{bool.NameAR}}
              </option>
            </ng-container>
          </select>
          <div *ngIf="submitted && Validate.AcceptRetail?.errors" class="red">
            <div *ngIf="Validate.AcceptRetail?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
          </div>
        </div>
        <!--توجد عروض بديلة-->
        <div class="form-group">
          <label for="HaveAlternativeOffers">{{'ADMIN_USER.E_TENDER_FORM.HAVE_ALTERNATIVE_OFFERS' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <select id="HaveAlternativeOffers" name="HaveAlternativeOffers" class="form-control"
            formControlName="HaveAlternativeOffers">
            <ng-container *ngFor="let bool of booleans">
              <option *ngIf="displayedLang=='NameEN'" [value]="bool.Id">
                {{bool.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="bool.Id">
                {{bool.NameAR}}
              </option>
            </ng-container>
          </select>
          <div *ngIf="submitted && Validate.HaveAlternativeOffers?.errors" class="red">
            <div *ngIf="Validate.HaveAlternativeOffers?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
          </div>
        </div>
        <!--نظام التقييم-->
        <div class="form-group">
          <label for="EvaluationSystemId">{{'ADMIN_USER.E_TENDER_FORM.EVALUATION_SYSTEM' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <select id="EvaluationSystemId" name="EvaluationSystemId" class="form-control"
            formControlName="EvaluationSystemId" (change)="evaluationSystemIdChanged($event)">
            <ng-container *ngFor="let evaluationSystem of EvaluationSystems">
              <option *ngIf="displayedLang=='NameEN'" [value]="evaluationSystem.Id">
                {{evaluationSystem.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="evaluationSystem.Id">
                {{evaluationSystem.NameAR}}
              </option>
            </ng-container>
          </select>
          <div *ngIf="submitted && Validate.EvaluationSystemId?.errors" class="red">
            <div *ngIf="Validate.EvaluationSystemId?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
          </div>
        </div>
        <!--*الحد الأدنى لقبول العرض الفني (عدد النقاط)-->
        <div class="form-group" *ngIf="createTenderForm.controls['EvaluationSystemId']?.value == 1">
          <label
            for="MinimumAcceptancePointsForTechnicalOffer">{{ 'ADMIN_USER.E_TENDER_FORM.MINIMUM_ACCEPTANCE_POINTS_FOR_TECHNICAL_OFFER' | translate }}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <input type="number" id="MinimumAcceptancePointsForTechnicalOffer" class="form-control"
            name="MinimumAcceptancePointsForTechnicalOffer" formControlName="MinimumAcceptancePointsForTechnicalOffer"
            min="0" onkeypress="return event.charCode >= 48" />
          <div *ngIf="submitted && Validate.MinimumAcceptancePointsForTechnicalOffer?.errors" class="red ">
            <div *ngIf="Validate.MinimumAcceptancePointsForTechnicalOffer?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.MinimumAcceptancePointsForTechnicalOffer?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
          </div>
        </div>
        <!--Specialities-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['TenderTypeId']?.value == ETenderTypes.LimitedTender || createTenderForm.controls['TenderTypeId']?.value == ETenderTypes.Practice">
          <label for="msSpeciality">{{ 'FRONT_USER.SUPPLIER_LISTING_REPORT.SPECIALITY' | translate }}</label>
          <ng-multiselect-dropdown id="msSpeciality" [formControl]="Validate['ETenderSpecialities']"
            placeholder="{{ 'FRONT_USER.SUPPLIER_LISTING_REPORT.SPECIALITY' | translate }}" 
            [settings]="dropdownSettings"  [data]="SpecialitiesList" [disabled]="formMode == 2"
            (onDropDownClose)="SpecialitiesChanged()">
          </ng-multiselect-dropdown>
        </div>

        <!--Suppliers-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['TenderTypeId']?.value == ETenderTypes.LimitedTender || createTenderForm.controls['TenderTypeId']?.value == ETenderTypes.Practice">
          <label for="msSupplier">{{ 'ADMIN_USER.E_TENDER_FORM.ETENDERS_SUPPLIERS' | translate }}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <ng-multiselect-dropdown id="msSupplier" [formControl]="Validate['ETenderSuppliers']"
            placeholder="{{ 'ADMIN_USER.E_TENDER_FORM.ETENDERS_SUPPLIERS' | translate }}" 
            [settings]="suppliersDropdownSettings" [data]="suppliersList" [disabled]="formMode == 2">
          </ng-multiselect-dropdown>
          <div *ngIf="submitted && Validate.ETenderSuppliers?.errors" class="red">
            <div *ngIf="Validate.ETenderSuppliers?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
          </div>
        </div>
        <!--Assign Technical Category Admin(s)-->
        <div class="form-group" *ngIf="formMode != 2">
          <label for="msTechnicalAdmins">{{ 'ADMIN_USER.E_TENDER_FORM.TECHNICAL_ADMINS' | translate }}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <ng-multiselect-dropdown id="msTechnicalAdmins" [formControl]="Validate['TechnicalAdmins']"
            placeholder="{{ 'ADMIN_USER.E_TENDER_FORM.TECHNICAL_ADMINS' | translate }}" 
            [settings]="adminsDropdownSettings" [data]="TechnicalAdminsList"
             [disabled]="false">
          </ng-multiselect-dropdown>

          <div *ngIf="submitted && Validate.TechnicalAdmins?.errors" class="red">
            <div *ngIf="Validate.TechnicalAdmins?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
          </div>
        </div>
        <!--Assign Purchasing Category Admin(s)-->
        <div class="form-group" *ngIf="formMode != 2">
          <label for="msPurchasingAdmins">{{ 'ADMIN_USER.E_TENDER_FORM.PURCHASING_ADMINS' | translate }}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <ng-multiselect-dropdown id="msPurchasingAdmins" [formControl]="Validate['PurchasingAdmins']"
            placeholder="{{ 'ADMIN_USER.E_TENDER_FORM.PURCHASING_ADMINS' | translate }}" [settings]="adminsDropdownSettings" 
            [data]="PurchasingAdminsList"
            [disabled]="false">
          </ng-multiselect-dropdown>
          <div *ngIf="submitted && Validate.PurchasingAdmins?.errors" class="red">
            <div *ngIf="Validate.PurchasingAdmins?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
          </div>
        </div>
        <!--ملاحظات-->
        <div class="form-group"
          *ngIf="createTenderForm.controls['Language']?.value == 1 || createTenderForm.controls['Language']?.value == 3">
          <label for="CommentsAr">{{ 'ADMIN_USER.E_TENDER_FORM.ARABIC_COMMENTS' | translate}}</label>
          <textarea formControlName="CommentsAr" name="CommentsAr" class="form-control"></textarea>
          <div *ngIf="submitted && Validate.CommentsAr?.errors" class="red ">
            <div *ngIf="Validate.CommentsAr?.errors?.pattern">
              {{'ADMIN_USER.SHARED.PATTERN' | translate}}
            </div>
          </div>
        </div>
        <!--ملاحظات En -->
        <div class="form-group"
          *ngIf="createTenderForm.controls['Language']?.value == 2 || createTenderForm.controls['Language']?.value == 3">
          <label for="CommentsEn">{{ 'ADMIN_USER.E_TENDER_FORM.ENGLISH_COMMENTS' | translate}}</label>
          <textarea formControlName="CommentsEn" name="CommentsEn" class="form-control"></textarea>
          <div *ngIf="submitted && Validate.CommentsEn?.errors" class="red ">
            <div *ngIf="Validate.CommentsEn?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
            <div *ngIf="Validate.CommentsEn?.errors?.maxlength">
              {{'ADMIN_USER.SHARED.TOO_LONG' | translate}}
            </div>
            <div *ngIf="Validate.CommentsEn?.errors?.pattern">
              {{'ADMIN_USER.SHARED.PATTERN' | translate}}
            </div>
          </div>
        </div>
        <!--Assign Tender Manager-->
        <div class="form-group" *ngIf="formMode != 2">
          <label for="ETenderManagerId">{{'ADMIN_USER.E_TENDER_FORM.ETENDER_MANAGER' | translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <select id="ETenderManagerId" name="ETenderManagerId" class="form-control" formControlName="ETenderManagerId"
            *ngIf="formMode != 2">
            <ng-container *ngFor="let eTenderManager of ETenderManagers">
              <option [value]="eTenderManager.Id">
                {{eTenderManager.Username}}
              </option>
            </ng-container>
          </select>
          <ng-container *ngFor="let eTenderManager of ETenderManagers">
            <span class="form-control"
              *ngIf="formMode == 2 && eTenderManager.Id == model.ETenderManagerId">{{eTenderManager.Username}}</span>
          </ng-container>
          <div *ngIf="submitted && Validate.ETenderManagerId?.errors" class="red">
            <div *ngIf="Validate.ETenderManagerId?.errors?.required">
              {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
          </div>
        </div>
        <div class="form-container">
          <!--تاريخ فتح المظاريفoffer deadline-->
          <div class="form-group" *ngIf="createTenderForm.controls['TenderTypeId']?.value != ETenderTypes.Quotations">
            <label for="OD">{{ 'ADMIN_USER.E_TENDER_FORM.OFFER_DEADLINE' | translate}}</label>
            <span class="red" *ngIf="formMode != 2"> *</span>
            <div class="split-form-group">
              <input class="form-control OD" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="OD"
                [minDate]="getMinDeadlineDate" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                [ngClass]="{ 'is-invalid': submitted ||(Validate.OD?.dirty  && Validate.OD?.errors) }">
              <timepicker id="ODTime" formControlName="ODTime" [hourStep]="1" [minuteStep]="1"
                [disabled]="formMode == 2"></timepicker>
            </div>
            <div *ngIf="submitted  && (Validate.ODTime?.errors||Validate.OD?.errors)" class="red ">
              <div>{{'ADMIN_USER.SHARED.REQUIRED' | translate}}</div>
            </div>
            <div class="red" *ngIf="showPublishDateGreaterThanOfferDeadLineMessage">
              {{'ADMIN_USER.E_TENDER_FORM.PUBLISHING_DATE_GREATER_THAN_OFFER_DEADLINE_MESSAGE' | translate}}
            </div>
          </div>
          <!--* Clarification Duration Start Date & Time-->
          <div class="form-group">
            <label
              for="CDStartDate">{{ 'ADMIN_USER.E_TENDER_FORM.CLARIFICATION_DURATION_START_DATE' | translate}}</label>
            <span class="red" *ngIf="formMode != 2"> *</span>
            <div class="split-form-group ">
              <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="CDStartDate"
                [minDate]="getMinClarificationStartDate" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                [ngClass]="{ 'is-invalid': submitted ||(Validate.CDStartDate?.dirty  && Validate.CDStartDate?.errors) }">
              <timepicker id="CDStartDateTime" formControlName="CDStartDateTime" [hourStep]="1" [minuteStep]="1"
                [disabled]="formMode == 2">
              </timepicker>
            </div>
            <div *ngIf="submitted  && ( Validate.CDStartDateTime?.errors|| Validate.CDStartDate?.errors)" class="red ">
              <div>{{'ADMIN_USER.SHARED.REQUIRED' | translate}}</div>
            </div>
            <div class="red" *ngIf="showStartDateGreaterThanOfferDeadLineMessage">
              {{'ADMIN_USER.E_TENDER_FORM.START_DATE_GREATER_THAN_OFFER_DEADLINE_MESSAGE' | translate}}
            </div>
            <div class="red" *ngIf="showStartDateGreaterThanEndDateMessage">
              {{'ADMIN_USER.E_TENDER_FORM.START_DATE_GREATER_THAN_END_DATE_MESSAGE' | translate}}
            </div>
            <div class="red" *ngIf="showPublishDateGreaterThanStartDateMessage">
              {{'ADMIN_USER.E_TENDER_FORM.PUBLISHING_DATE_GREATER_THAN_START_DATE_MESSAGE' | translate}}
            </div>
          </div>
          <!--* Clarification Duration End Date & Time-->
          <div class="form-group">
            <label for="CDEndDate">{{ 'ADMIN_USER.E_TENDER_FORM.CLARIFICATION_DURATION_END_DATE' | translate}}</label>
            <span class="red" *ngIf="formMode != 2"> *</span>
            <div class="split-form-group ">
              <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="CDEndDate"
                [minDate]="getMinClarificationEndDate" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                [ngClass]="{ 'is-invalid': submitted ||(Validate.CDEndDate?.dirty  && Validate.CDEndDate?.errors) }">
              <timepicker id="CDEndDateTime" formControlName="CDEndDateTime" [hourStep]="1" [minuteStep]="1"
                [disabled]="formMode == 2"></timepicker>
            </div>
            <div *ngIf="submitted  && (Validate.CDEndDateTime?.errors||Validate.CDEndDate?.errors)" class="red ">
              <div>{{'ADMIN_USER.SHARED.REQUIRED' | translate}}</div>
            </div>
            <div class="red" *ngIf="showEndDateGreaterThanOfferDeadLineMessage">
              {{'ADMIN_USER.E_TENDER_FORM.END_DATE_GREATER_THAN_OFFER_DEADLINE_MESSAGE' | translate}}
            </div>
            <div class="red" *ngIf="showPublishDateGreaterThanEndDateMessage">
              {{'ADMIN_USER.E_TENDER_FORM.PUBLISHING_DATE_GREATER_THAN_END_DATE_MESSAGE' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="form-container">
        <h4 class="section-title">{{ 'ADMIN_USER.E_TENDER_FORM.ATTACHMENTS' | translate}}</h4>
        <!--كراسة الشروط-->
        <div class="form-group" *ngIf="formMode != 2">
          <label>{{'ADMIN_USER.E_TENDER_FORM.BOOKLET'|translate}}</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <input type="file" class="form-control" MaxSizeInMB="50"
            accept=".pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc,.docx,.rar,.zip" id="Booklet" formControlName="Booklet"
            (change)="AddAttachmentFile($event, Validate.Booklet, 'CreateTender_Booklet', ETenderAttachmentType.Booklet, 'BookletProgress')" />          
          <div class="upload-info">
            <span>{{'ADMIN_USER.SHARED.ETENDER_ALLOWED_FILE_EXTENSIONS' | translate}}</span>
          </div>
          <div class="progress" *ngIf="formMode != 2">
            <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
              [style.width]="BookletProgress + '%'">
              <span class=""> {{BookletProgress}} % Complete</span>
            </div>
          </div>
          <div *ngIf="submitted && (Validate.Booklet?.errors && booklet.URL ==null)" class="red ">
            <div *ngIf="Validate.Booklet?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}
            </div>
            <div *ngIf="Validate.Booklet?.errors?.notCompleted">
              {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
            </div>
          </div>
        </div>
        <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add && booklet.URL !=null">
          <label>{{'ADMIN_USER.E_TENDER_FORM.BOOKLET'|translate}}</label>

          <a [attr.href]="booklet.URL" target="_blank">
            <i class="icon-view-file"></i>
            {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}</a>
        </div>
      </div>
      <div *ngIf="model?.Status==2">
        <fieldset [disabled]="true">
          <div class="form-container">
            <h4 class="section-title">{{ 'ADMIN_USER.E_TENDER_FORM.CANCEL_TENDER' | translate}}</h4>
            <!--cancellation reason -->
            <div class="form-group">
              <label for="CancellationReason">{{ 'ADMIN_USER.E_TENDER_FORM.CANCELLATION_REASON' | translate}}</label>
              <textarea formControlName="CancellationReason" name="CancellationReason" class="form-control"></textarea>
            </div>
            <!--attachments-->
            <div class="form-group read-uploaded" *ngIf="cancellationDoc.URL != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.ATTACHMENTS'|translate}}</label>

              <a [attr.href]="cancellationDoc.URL" target="_blank">
                <i class="icon-view-file"></i>
                {{cancellationDoc.DocumentName}}</a>
            </div>
          </div>
        </fieldset>
      </div>
    </fieldset>
    <div class="form-group" *ngIf="formMode != 2">
      <button [disabled]="loading" class="btn btn-primary SCAcustomBtn" Confirmation
        (confirmationClick)="onSubmit()">{{ 'FRONT_USER.SAVE' | translate}}</button>
    </div>
  </form>
</div>
<!-- Confirmation -->
<div *ngIf="!showRequest && IsSuccess" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p> {{ message }}</p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>
<!--Messaging-->

<app-messaging *ngIf="isAdmin && isSupplierAvailabale && showRequest" MessagingBoxTitle="Clarifications">
</app-messaging>

<app-messaging *ngIf="isAdmin && !isSupplierAvailabale && showRequest" MessagingBoxTitle="GeneralMessages">
</app-messaging>